import { render, staticRenderFns } from "./HeaderStripes.vue?vue&type=template&id=5aaded21&scoped=true&"
var script = {}
import style0 from "./HeaderStripes.vue?vue&type=style&index=0&id=5aaded21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaded21",
  null
  
)

export default component.exports